/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, StyleSheet } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import ProductBadge from '@components/global/ProductBadge';
import Table from '@components/table/Table';
import { Loader } from '@components/screen/Layout';
import ProductItemMobile from '@/screens/catalog/components/ProductItemMobile';
import ModalDetailProduct from '@components/transaction/catalog/ModalDetailProduct';

import { isWeb, fullWidth } from '@global/screens';
import { convertProductMarketType, hasProductBadge } from '@global/helpers';
import useApi from '@/hooks/useApi';
import { MsCatalog } from '@api/ms-catalog';
import { setProductData } from '@/store/product';

import PropTypes from 'prop-types';

const propTypes = {
  id: PropTypes.string,
  navigation: PropTypes.object,
};

const defaultProps = {
  id: '',
  navigation: {},
};

const tableStructure = {
  image: {
    head: 'Product Image',
    body: 'image',
    type: 'image',
  },
  reference: {
    head: 'Internal Reference',
    body: 'reference',
    type: 'slot',
  },
  name: {
    head: 'Name',
    body: 'name',
  },
  variant: {
    head: 'Attribute Value',
    body: 'variant',
  },
  price: {
    head: 'Price',
    body: 'price',
    type: 'currency',
  },
  attribute: {
    head: 'Attribute',
    body: 'attribute',
    type: 'slot',
  },
};

const ProductTab = (props) => {
  const { id } = props;
  const dispatch = useDispatch();
  const productDetail = useSelector((state) => state.product.productData);

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);

  const getCMSSectionDetail = useApi(MsCatalog.getCMSSectionDetail);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      doSearch();
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const doSearch = async () => {
    setLoading(true);
    try {
      const response = await getCMSSectionDetail.request(id, 'products');
      if (response?.data?.data?.length) {
        const new_response = response.data.data.map((pr) => {
          return convertProductMarketType(pr.products);
        });
        setTableData(new_response);
      } else {
        setTableData([]);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const gotToDetail = (data) => {
    dispatch(setProductData(data));
  };

  const onCloseDetail = () => {
    dispatch(setProductData({}));
  };

  return (
    <>
      {isWeb ? (
        <View style={styles.tablePadding}>
          <Table
            name={'catalog-promo-detail'}
            structures={tableStructure}
            data={tableData}
            loading={loading}
            hasNoHide
            rowBottomBorder
            showFilter={false}
            showSearch={false}
            showPagination={false}
            totalData={10}
            slot={{
              reference: ({ data, index }) => (
                <SociollaText
                  style={{ fontSize: 13 }}
                  key={`reference-${index}`}>
                  {data?.reference ? `[${data.reference}]` : '-'}
                </SociollaText>
              ),
              attribute: ({ data, index }) => (
                <View
                  style={{ flexDirection: 'row', flexWrap: 'wrap' }}
                  key={`slot-attribute-${index}`}>
                  {data.is_best_seller ? (
                    <ProductBadge status="best" style={{ marginLeft: 5 }} />
                  ) : (
                    false
                  )}
                  {data.is_promo ? (
                    <ProductBadge status="promo" style={{ marginLeft: 5 }} />
                  ) : (
                    false
                  )}
                  {data.is_new ? (
                    <ProductBadge status="new" style={{ marginLeft: 5 }} />
                  ) : (
                    false
                  )}
                  {!hasProductBadge(data) ? (
                    <SociollaText>-</SociollaText>
                  ) : (
                    false
                  )}
                </View>
              ),
            }}
            onClickRow={({ data }) => gotToDetail(data)}
            onSearch={(value) => doSearch(value)}
          />
        </View>
      ) : loading ? (
        <Loader />
      ) : tableData?.length ? (
        tableData.map((item, idx) => (
          <View style={styles.itemMobile} key={idx}>
            <ProductItemMobile
              data={item}
              onCallback={() => gotToDetail(item)}
            />
          </View>
        ))
      ) : (
        false
      )}

      <ModalDetailProduct
        back={!isWeb}
        withPromotion
        title="Product Detail"
        show={Boolean(productDetail && Object.keys(productDetail).length)}
        onClose={() => onCloseDetail()}
      />
    </>
  );
};

ProductTab.propTypes = propTypes;
ProductTab.defaultProps = defaultProps;

const styles = StyleSheet.create({
  itemMobile: {
    width: fullWidth,
    // marginLeft: -15,
  },
  tablePadding: {
    paddingHorizontal: 15,
  },
});

export default React.memo(ProductTab, (prev, next) => prev == next);
